import { z } from "zod";
import {
  ChassisSchema,
  LocalizedTextSchema,
  ManufacturerSchema,
  RoleSchema,
  SUPPORT_CHASSIS,
  TIER_ABILITY_COUNT,
  TierSchema,
  idPattern,
} from "./common.js";

export const AbilityRefSchema = z.object({
  archetype: idPattern("abl"),
  name: LocalizedTextSchema,
  params: z.record(z.string(), z.number()),
});
export type AbilityRef = z.infer<typeof AbilityRefSchema>;

export const UnitDefSchema = z
  .object({
    id: idPattern("unit"),
    name: LocalizedTextSchema,
    mfr: ManufacturerSchema,
    chassis: ChassisSchema,
    role: RoleSchema,
    tier: TierSchema,
    standard: AbilityRefSchema,
    uniques: z.array(AbilityRefSchema).max(4),
    bio: LocalizedTextSchema,
  })
  .superRefine((u, ctx) => {
    const expected = TIER_ABILITY_COUNT[u.tier] - 1;
    if (u.uniques.length !== expected)
      ctx.addIssue({ code: "custom", message: `${u.tier} tier needs ${expected} unique abilities`, path: ["uniques"] });
    if (u.role === "support" && !SUPPORT_CHASSIS.includes(u.chassis))
      ctx.addIssue({ code: "custom", message: "supports must be androids or drone carriers", path: ["chassis"] });
    if (u.role !== "support" && u.chassis === "drone_carrier")
      ctx.addIssue({ code: "custom", message: "drone carriers are support only", path: ["chassis"] });
  });
export type UnitDef = z.infer<typeof UnitDefSchema>;
